import styled, { keyframes } from "styled-components"
import { overloadColor } from "../../util/style"

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
interface SpinnerStrokeProps {
  size: number
  thickness: number
  colorPrimary: string
  colorSecondary: string
  duration: number
}
export const SpinnerStroke = styled.div<SpinnerStrokeProps>`
  border-radius: 50%;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;

  &::after {
    border-radius: 50%;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
  }

  text-indent: -9999em;
  border-top: ${(props) => props.thickness}px solid
    ${(props) => overloadColor(props.colorSecondary)};
  border-right: ${(props) => props.thickness}px solid
    ${(props) => overloadColor(props.colorSecondary)};
  border-bottom: ${(props) => props.thickness}px solid
    ${(props) => overloadColor(props.colorSecondary)};
  border-left: ${(props) => props.thickness}px solid
    ${(props) => overloadColor(props.colorPrimary)};
  transform: translateZ(0);
  animation: ${rotateAnimation} ${(props) => props.duration}s infinite linear;
`
